<template>
<div>
  <v-flex xs10 offset-xs1>
    <div class="fl hf mb-5" style='align-items: flex-end;'>
      <div class='golden-left mr-4'>
        <!-- <p class="view-sub-title">{{ 'employees.details-title' | translate}}</p> -->
        <div class='fl mb-4' style='align-items: center'>
          <div class='mr-3'>
            <PersonPortrait :firstName="employee.initials" :lastName='employee.lastName' :scale="1"/>
          </div>
          <h1 style="font-size: 2.2em">
            {{employee.initials}} {{employee.middleName}} {{employee.lastName}}
            <span v-if="employee.lastNamePartner">- {{ employee.middleNamePartner }} {{ employee.lastNamePartner }}</span>
          </h1>

        </div>
        <p>{{ $t('employees.details-description').replace(/\[\[full-name\]\]/g, employee.getFullName()).replace(/\[\[possesive\]\]/g, this.getGenderPossesive()) }}</p>
      </div>

      <div class='golden-right'>
        <new-report-of-sickness-card-button v-if="!hasActiveReportOfSickness" style='float: right; max-width: 180px;' @click="handleNewReportOfSicknessClick"/>
      </div>
    </div>
  </v-flex>

  <v-flex xs10 offset-xs1>
    <!-- <EmployeeYearTimeline :employee="this.employee" :reportOfSickness="this.reportsOfSickness" class='mb-5'/> -->
    <div class='hf fl'>
      <div class='golden-right' style='padding-left: 0px; padding-right: 50px;'>
        <employee-personal-info :employee="employee" class='mb-5'/>
        <employee-reports-of-sickness :employee="employee"/>
        <employee-uwv-decisions :employee="employee" />
        <!-- <report-of-sickness-details-employee :employee="employee" class='mb-5' /> -->
      </div>
      <div class='golden-left'>
        <employee-policies :employee="employee" class='shadowed mb-5'/>
        <employee-employment-relationships :employee="employee" :employmentRelationships="employee.employmentRelationships" class='mb-5' />
      </div>
    </div>
  </v-flex>
</div>
</template>

<script>
import PersonPortrait from '@aevitae/aevitaeui/0_atoms/containers/PersonPortrait.vue';

import NewReportOfSicknessCardButton from '@/views/components/generic/NewReportOfSicknessCardButton.vue';

// import EmployeeYearTimeline from '@/views/components/employee-details/employee-year-timeline/EmployeeYearTimeline.vue';
import EmployeePersonalInfo from '@/views/components/employee-details/EmployeePersonalInfo.vue';
import EmployeePolicies from '@/views/components/employee-details/EmployeePolicies.vue';
import EmployeeReportsOfSickness from '@/views/components/employee-details/EmployeeReportsOfSickness.vue';
import EmployeeEmploymentRelationships from '@/views/components/employee-details/EmployeeEmploymentRelationships.vue';
import EmployeeUwvDecisions from '@/views/components/employee-details/EmployeeUwvDecisions.vue';

import HelperFunctions from '@/shared/helpers/functions';
import Compositions from '@/views/helpers/compositions';

import Employee from '@/resources/models/employees';
import ReportsOfSicknessResource from '@/resources/constants/reports-of-sickness';
import NewReportOfSickness from '@/views/constants/report-of-sickness-new';
import ReportsOfSicknessView from '@/views/constants/reports-of-sickness';
import AppNavigation from '@/views/constants/app-navigation';

import Vue from 'vue';

export default {
  name: 'EmployeeDetails',
  props: {
    employeeId: Number
  },
  components: {
    PersonPortrait,

    // EmployeeYearTimeline,
    EmployeePersonalInfo,
    EmployeePolicies,
    EmployeeEmploymentRelationships,
    EmployeeReportsOfSickness,
    EmployeeUwvDecisions,

    NewReportOfSicknessCardButton
  },
  data () {
    return {
      headers: [
        { text: 'Eerste verzuimdag', value: 'firstOfAbsence' },
        { text: 'Arbeidsongeschiktheid', value: 'disabilityRate' },
        { text: 'Vangnet?', value: 'safetyNet' },
        { text: 'Ongeval?', value: 'accidentType' },
        { text: 'ID', value: 'id' },
        { text: 'Personeelsnummer', value: 'employeeId' }
      ],
      search: '',
      pagination: {
        sortBy: 'lastName',
        descending: false,
        rowsPerPage: 25
      },
      linkMenuLinks: [
        {
          text: 'Een nieuw verzuim indienen',
          onClick: this.handleNewReportOfSicknessClick
        }
      ]
    };
  },
  mounted () {
    this.$store.dispatch(ReportsOfSicknessResource.Actions.LoadForEmployee.START,
      { employerId: this.$store.getters.selectedEmployer.id, employeeId: this.employeeId });
  },
  computed: {
    employee () {
      let result = this.$store.getters.employees.find(empl => empl.id === this.employeeId);
      if (result == null) {
        result = new Employee();
      }
      return result;
    },
    reportsOfSickness () {
      return this.$store.getters.reportsOfSickness[this.employeeId];
    },
    hasActiveReportOfSickness () {
      return Compositions.getActiveReportOfSickness(this.reportsOfSickness).length > 0;
    }
  },
  methods: {
    handleNewReportOfSicknessClick () {
      this.$store.dispatch(AppNavigation.Actions.Navigate.DO, AppNavigation.Views.ReportsOfSickness)
        .then(this.$store.dispatch(ReportsOfSicknessView.Actions.Tabs.OPEN_NEW))
        .then(this.$store.dispatch(NewReportOfSickness.Actions.Form.CHANGE, { attribute: 'employeeId', value: this.employee.id }))
        .then(this.$store.dispatch(NewReportOfSickness.Actions.Steps.Completed.UPDATE))
        .then(this.$store.dispatch(NewReportOfSickness.Actions.Navigate.DO, NewReportOfSickness.Views.NewReportOfSicknessForm))
        .then(Vue.toasted.info(this.$t('employees.toasters.navigated-new-report-of-sickness-for-employee').replace('[[initials]]', this.employee.initials).replace('[[last-name]]', this.employee.lastName)));
    },

    getGenderPossesive () {
      if (this.employee) {
        if (this.employee.gender === 'Male') {
          return 'zijn';
        } else if (this.employee.gender === 'Female') {
          return 'haar';
        } else {
          return 'hun';
        }
      }
    },
    getFormattedDate (value) {
      return HelperFunctions.Dates.formatDate(value);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/stylesheets/variables.scss';
.profile-header {
  display: block;
  height: 80px;
  position: absolute;
  top: 0px;
  width: 100%;
  background-color: red;
}

.personel-number-indicator {
  position: relative;
  top: 5px;
  font-size: 1.4em;
  font-weight: 600;
  background-color: $secondary-lighten-4;
  color: $secondary-lighten-1;
  padding: 6px 16px;
  height: 48px;
  border-radius: $border-radius;
  margin-left: 20px;
}

h1 {
  span{
     color: $primary;
  }
}

</style>
